import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import type { RetainedBeaconChoice, RetainedBeaconEligibility } from '@/hooks/useRetainedBeaconDischarge';
import { RetainedBeaconDischargeChoice } from './RetainedBeaconDischargeChoice';

interface Props {
  open: boolean;
  eligibility?: RetainedBeaconEligibility | null;
  onChoose: (choice: RetainedBeaconChoice) => void | Promise<void>;
  onCancel: () => void;
  working?: boolean;
  errorMessage?: string | null;
}

export function RetainedBeaconChoiceDialog({
  open,
  eligibility,
  onChoose,
  onCancel,
  working = false,
  errorMessage,
}: Props) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth aria-labelledby="retained-beacon-choice-title">
      <DialogTitle id="retained-beacon-choice-title">Confirm Discharge</DialogTitle>
      <DialogContent>
        <RetainedBeaconDischargeChoice eligibility={eligibility} />
        {errorMessage && <DialogContentText color="error">{errorMessage}</DialogContentText>}
      </DialogContent>
      <DialogActions style={{ flexWrap: 'wrap', gap: 8, padding: '16px 24px' }}>
        <Button onClick={onCancel} color="secondary" disabled={working}>
          Cancel
        </Button>
        <Button
          onClick={() => onChoose('standard')}
          color="primary"
          variant="outlined"
          disabled={working}
          style={{ borderColor: 'currentColor' }}
        >
          Standard discharge
        </Button>
        <Button onClick={() => onChoose('retain')} color="primary" variant="contained" disabled={working}>
          Discharge and keep beacon
        </Button>
      </DialogActions>
    </Dialog>
  );
}
